import { useCallback, useEffect, useState } from "react";

const useChatsHotKeys = ({
  openChat,
  closeChat,
  exportChat,
}: {
  openChat: () => void;
  closeChat: () => void;
  exportChat: () => void;
}) => {
  const [isTransferDialogOpen, setIsTransferDialogOpen] = useState(false);
  const [isInviteDialogOpen, setIsInviteDialogOpen] = useState(false);

  const handleOpenInviteDialog = useCallback(() => {
    setIsTransferDialogOpen(false);
    setIsInviteDialogOpen(!isInviteDialogOpen);
  }, [isInviteDialogOpen]);

  const handleOpenTransferDialog = useCallback(() => {
    setIsInviteDialogOpen(false);
    setIsTransferDialogOpen(!isTransferDialogOpen);
  }, [isTransferDialogOpen]);

  const handleKeyboard = useCallback(
    (e: any) => {
      if (e.key === "Escape") {
        setIsInviteDialogOpen(false);
        setIsTransferDialogOpen(false);
      } else if (e.ctrlKey && (e.key === "I" || e.key === "i")) {
        e.preventDefault();
        handleOpenInviteDialog();
        (e.target as HTMLElement).focus();
      } else if (e.ctrlKey && (e.key === "J" || e.key === "j")) {
        e.preventDefault();
        handleOpenTransferDialog();
      } else if (e.ctrlKey && (e.key === "O" || e.key === "o")) {
        e.preventDefault();
        openChat?.();
      } else if (e.ctrlKey && (e.key === "K" || e.key === "k")) {
        e.preventDefault();
        closeChat?.();
      } else if (e.ctrlKey && (e.key === "E" || e.key === "e")) {
        e.preventDefault();
        exportChat?.();
      }
      return false;
    },
    [
      closeChat,
      exportChat,
      handleOpenInviteDialog,
      handleOpenTransferDialog,
      openChat,
    ]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyboard);
    return () => window.removeEventListener("keydown", handleKeyboard);
  }, [handleKeyboard]);

  return {
    isTransferDialogOpen,
    isInviteDialogOpen,
    setIsTransferDialogOpen,
    setIsInviteDialogOpen,
  };
};

export default useChatsHotKeys;
